export const WidgetLayouts = {
  halfWidth: {w: 3, minW: 1},
  thirdWidth: {w: 2, minW: 1},
  sixthWidth: {w: 1, minW: 1},
};
